import React from 'react';
import { Typography, FormControlLabel, Radio } from '@mui/material';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import BlockIcon from '@mui/icons-material/Block';
import { RATINGS } from 'utils/constants';
import { Analytics } from 'utils/analytics';
import { SectionContainer, HeaderContainer, StyledRadioGroup, OptionContainer } from '../FeedbackPage.styles';

interface FutureCollaborationProps {
  value: string;
  talentName: string;
  onChange: (value: string) => void;
}

const FutureCollaboration: React.FC<FutureCollaborationProps> = ({
  value,
  talentName,
  onChange,
}) => {
  const handleRatingChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const ratingValue = event.target.value;
    let ratingLabel = '';

    switch (ratingValue) {
      case RATINGS.VERY_HAPPY.toString():
        ratingLabel = 'Favourite';
        break;
      case RATINGS.PLEASED.toString():
        ratingLabel = 'Pleased';
        break;
      case RATINGS.UNHAPPY.toString():
        ratingLabel = 'Unhappy';
        break;
    }

    Analytics.track('submit rating', {
      rating: ratingLabel,
      talentName: talentName
    });

    onChange(ratingValue);
  };

  return (
    <SectionContainer>
      <HeaderContainer>
        <Typography variant="h6" component="h3">
          Future Collaboration (For TempStars internal use only)
        </Typography>
      </HeaderContainer>

      <StyledRadioGroup
        value={value}
        onChange={handleRatingChange}
      >
        <FormControlLabel
          value={RATINGS.VERY_HAPPY.toString()}
          control={<Radio />}
          label={
            <OptionContainer>
              <FavoriteBorderOutlinedIcon color="error" />
              <Typography>
                Designate {talentName} as a Favourite for future shifts
              </Typography>
            </OptionContainer>
          }
        />
        <FormControlLabel
          value={RATINGS.PLEASED.toString()}
          control={<Radio />}
          label={
            <Typography>
              {talentName} was fine but not a Favourite
            </Typography>
          }
        />
        <FormControlLabel
          value={RATINGS.UNHAPPY.toString()}
          control={<Radio />}
          label={
            <OptionContainer>
              <BlockIcon color="error" />
              <Typography>
                DO NOT book {talentName} with our office again
              </Typography>
            </OptionContainer>
          }
        />
      </StyledRadioGroup>
    </SectionContainer>
  );
};

export default FutureCollaboration;
